import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AWBService } from "src/app/services/operations/awb.service";
import Swal from "sweetalert2";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EditDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/edit-delete.component";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { lastValueFrom, switchMap } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ManifestService } from "src/app/services/operations/manifest.service";
import { AppCoreService } from "src/app/services/app-core.service";
// import { DualListComponent } from "angular-dual-listbox";
import { Utilities } from "src/app/models/utilities";
import { MiscService } from "src/app/services/misc/misc.service";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { Title } from "@angular/platform-browser";
import { NgSelectComponent } from "@ng-select/ng-select";

@Component({
  selector: 'app-bagging',
  templateUrl: './bagging.component.html',
  styleUrls: ['./bagging.component.scss']
})
export class BaggingComponent implements OnInit, AfterViewInit {
  @ViewChild('awbRef') awbRef!: NgSelectComponent; 
  bagForm: FormGroup;
  ediForm: FormGroup;
  isFormSubmitted: boolean;
  isEDIFormSubmitted: boolean;
  Id: number = null;
  source: any
  awbNoList = [];
  availableAwbList = [];
  bagList = [];

  childAWBNoList = [];
  isbagEditMode = false;
  sourceList: any[] = [];
  confirmedList = new Array<string>();
  DEFAULT_FORMAT = {
    add: 'Add to bag',
    remove: 'Remove from bag',
    all: 'All',
    none: 'None',
    // direction: DualListComponent.LTR,
    draggable: true,
  };
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight'
  }
  columnDefs = [
    { headerName: 'Bag no.', field: 'bagno', },
    { headerName: 'AWB Count', field: 'awbnumberscnt' },
    {
      headerName: 'Created Date',
      field: 'createddttm',
      cellRenderer: (params: { value: any }) => {
        const { dateString } = this.utilities.FormatDateWithTime(0, params.value);
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
      },
    },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      colId: 'params',
      editable: false,
    },
  ];
  editableList: any[] = [];
  columnDefsDetails = [
    { headerName: 'AWB Number', field: 'awbnumber' },
    {
      headerName: 'Created Date',
      field: 'createddttm',
      cellRenderer: (params: { value: any }) => {
        const { dateString } = this.utilities.formatDate(params.value);
        return dateString;
      },
    },
    // {
    //   headerName: 'Actions',
    //   field: 'id',
    //   cellRenderer: AWBDeleteActionsRenderer,
    //   colId: 'params',
    //   editable: false,
    // },
  ];
  dualElement: any
  rowDataBag = [];
  rowDataBagDetails = [];
  addedAWBs = [];
  userServiceCenter: any;
  selectedSCId: number;
  useEnterKey: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private awbService: AWBService,
    private ngxLoaderService: NgxUiLoaderService,
    private manifestService: ManifestService,
    public modalService: NgbModal,
    private appCoreService: AppCoreService,
    public utilities: Utilities,
    private miscService: MiscService,
    private configService: ConfigService,
    private titleService: Title

  ) {
    titleService.setTitle('Manifest');
    this.context = { componentParent: this };
  }

  ngOnInit(): void {
    this.bagForm = this.formBuilder.group({
      ddlAwb: [[], Validators.compose([Validators.required])],
    });
    this.ediForm = this.formBuilder.group({
      txtPrefix: [null, Validators.required],
      txtEDINoSeries: [null, Validators.compose([Validators.required, Validators.maxLength(5)])],
    });

    this.checkPermission();

    if (this.permConfig.isAddAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe((val) => {
        this.selectedSCId = val;
        // console.log('this.selectedSCId', this.selectedSCId);
        this.getAllAvailableAwb();
        this.getAllBags();
        this.getEDIConfig();
      });
    }
  }

  ngAfterViewInit() {
    this.useEnterKey ? this.utilities.focusFirstElement(this.bagForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Manifests');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  saveEdiNo() {
    this.isEDIFormSubmitted = true;
    if (this.ediForm.valid) {
      const ediDetails = {
        type: 'edi',
        configDetails: {
          edinoprefix: this.ediForm.get('txtPrefix').value,
          edinostartfrom: this.ediForm.get('txtEDINoSeries').value
        }
      }
      try {
        this.ngxLoaderService.start();
        this.configService.ManageConfigs(ediDetails).subscribe(res => {
          if (res?.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Record saved successfully.', 'Success', 'success');
            this.ediForm.reset();
            this.isEDIFormSubmitted = false;
          }
        })
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    }
  }

  async getAllAvailableAwb() {
    try {
      this.ngxLoaderService.start();
      const res = await lastValueFrom(this.awbService.getAwbReceivedList(this.selectedSCId));
      if (res && res?.success) {
        this.ngxLoaderService.stop();
        this.awbNoList = res.data;
        this.availableAwbList = res.data?.filter(x => x.parentawbnumber != null && x.parentawbnumber !== '')
                                        .map(x => ({ parentawbnumber: x.parentawbnumber, awbnumber: x.awbnumber }));
      }
    } catch (e) {
      this.ngxLoaderService.stop();
    }
  }
  

  async getAllBags() {
    try {
      this.ngxLoaderService.start();
      const res = await lastValueFrom(this.manifestService.GetAllBags(this.selectedSCId));
      if (res && res.success) {
        this.ngxLoaderService.stop();
        this.bagList = res.data.map(x => ({ ...x, createddttm: this.utilities.formatDate(x.createddttm, 'dd-mm-yyyy')?.dateString }));
        // const data = res.data.map(bag => ({
        //   ...bag,
        //   awbCount: bag.awbnumbers.length,
        //   gridType: 'bagListGrid'
        // }));
        // this.rowDataBag = data;
      }
    }
    catch (e) {
      console.log(e);
      this.ngxLoaderService.stop();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  async deleteAction(cell: any) {
    let confirm;
    if (this.isbagEditMode) {
      this.appCoreService.showMessage('You cannot perform delete when you are editing.', 'Error', 'error');
      return;
    }
    confirm = await this.deleteConfirmationDialog('<span>Are you sure you want to delete ?</span>');
    if (confirm) {
      this.manifestService.DeleteBag({ id: cell.id, scid: this.selectedSCId }).subscribe(res => {
        if (res && res.success) {
          this.resetToDefault();
          this.getAllAvailableAwb();
          this.getAllBags();
          this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success')
        }
      })
    }

  }

  async deleteConfirmationDialog(msg: string) {
    const result = await Swal.fire({
      // titleText: 'Confirmation',
      html: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    } else {
      return false;
    }
  }

  editAction(row: any) {
    this.Id = row.id;
    this.isbagEditMode = true;
    this.view(row.id);
  }

  view(rowId: any) {
    // console.log('rowId', rowId);
    const selectedBag = this.bagList.filter(x => x.id === rowId);
    // console.log('selectedBag', selectedBag);
    if (selectedBag.length) {
      for (const n of selectedBag[0].numbers as any[]) {
        this.availableAwbList = [...this.availableAwbList, n];
      }
      // update drop down for pre selected values
      this.bagForm.patchValue({
        ddlAwb: selectedBag[0].awbnumbers
      });

    }

    // console.log('this.availableAwbList', this.availableAwbList);

  }

  manageBag() {
    try {
      this.isFormSubmitted = true;
      if (this.bagForm.valid) {
        const requestObj = {
          id: this.Id,
          // awblist: this.confirmedList,
          awblist: this.bagForm.get('ddlAwb').value,
          generatedfromid: this.selectedSCId,
          updates: this.isbagEditMode
        };

        // console.log(requestObj);

        this.ngxLoaderService.start();
        this.manifestService.ManageBag(requestObj).subscribe(async (res) => {
          if (res) {
            if (res.error) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage(res.message, 'Error', 'error');
              setTimeout(() => {
                this.awbRef.focus();
              }, 400);
            }
            if (res.success) {
              this.ngxLoaderService.stop();
              this.resetToDefault();
              await this.getAllBags();
              this.appCoreService.showMessage('Record saved successfully.', 'Success', 'success');
              setTimeout(() => {
                this.awbRef.focus();
              }, 400);
              // this.Id = res.data[0].id;

            }
          }
        });
      }


    } catch (err) {
      console.error(err);
      this.ngxLoaderService.stop();
    }
  }

  cancelUpdates() {
    this.resetToDefault();
    this.gridOptions.api.setRowData(this.bagList);
    this.gridOptions.api.refreshCells({ force: true });
  }

  async resetToDefault() {
    this.isFormSubmitted = false;
    this.bagForm.reset();
    this.bagForm.updateValueAndValidity();
    this.isbagEditMode = false;
    this.availableAwbList = this.awbNoList.filter(x => x.parentawbnumber !== '');

  }

  getEDIConfig() {
    this.configService.GetAll({ searchkey: 'edi' }).subscribe((res) => {
      if (res?.success) {
        const ediConfig: any = res?.data;
        this.ediForm.get('txtPrefix').setValue(ediConfig?.edinoprefix);
        this.ediForm.get('txtEDINoSeries').setValue(ediConfig?.edinostartfrom);
      }
    })
  }
}